<template>
  <b-row>
    <m-data-diagnostic />
    <b-col class="m-cards-col" cols="12" md="12" lg="4" xl="4">
      <div class="m-card" v-if="position1 === 'blank'">
        <div class="spinner"></div>
      </div>
      <div class="m-card" v-if="position1 == 'point'">
        <b-row>
          <b-col cols="3" class="min-col-border">
            <!--<b-img src = "https://lorempixel.com/300/150/" fluid></b-img>-->
            <img :src="$store.state.site.UserImg" class="user x-large" />
          </b-col>
          <b-col cols="9">
            <p>
              Welcome <strong>{{ $store.state.site.User_FullName }}!</strong
              ><br />
              <span class="dated"
                >CUSTOMER SINCE
                {{ states.userInfo.CrtTimestamp | formatYear }}</span
              >
            </p>

            <div id="rewards">
              Rewards Points<br />
              <span class="points">{{
                states.userPoint | numberFormat("", 0)
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <a
            class="btn btn-outline-primary"
            href="javascript:void(0)"
            @click="$router.push('reward')"
            >REDEEM POINTS</a
          >
        </b-row>
      </div>
    </b-col>
    <b-col class="m-cards-col" cols="12" md="12" lg="4" xl="4">
      <div class="m-card" v-if="position2 === 'blank'">
        <div class="spinner"></div>
      </div>
      <div
        class="m-card"
        style="text-align: center"
        v-if="position2 == 'video'"
      >
        <!-- <a data-fancybox href="https://vimeo.com/305828142">
            <img src="https://www.sl360.com/images/sl360_video_thumb_V6.jpg" alt="SL360 Video Tour" style="max-width:300px;width:100%;" />
          </a> -->
      </div>
      <m-card-order
        v-if="position2 == 'recentOrder'"
        orderType="recentOrder"
        :orders="states.recentOrder"
        style="margin-top: 24px"
        ><span slot="title" style="display: flex"
          ><div>Recent Order&nbsp;</div>
          <!-- <a data-fancybox href="https://vimeo.com/388283376/beebf2a74b">
            <img src="../../assets/images/video-play-16.png" alt="Video" /> </a -->
        ></span>
        <a slot="footer" :href="$store.getters['config/link']('history')"
          >VIEW MORE ></a
        ></m-card-order
      >
    </b-col>
    <b-col class="m-cards-col" cols="12" md="12" lg="4" xl="4">
      <div class="m-card" v-if="position3 === 'blank'">
        <div class="spinner"></div>
      </div>
      <div class="m-card" v-if="position3 == 'refer'">
        <b-row>
          <p style="margin-top: -12px">
            New Data Diagnostic! The Data Diagnostic is a report that shows the
            accuracy of your postal, phone, and email data compared to industry
            norms, and the potential cost savings and revenue boost you can
            expect by refreshing your data. If your database has 100,000 or more
            records, you are eligible for a FREE Data Diagnostic.
          </p>
        </b-row>
        <b-row class="m-card-footer">
          <a href="#" @click="dataDiagnostic" class="btn btn-outline-primary"
            >Tell Me More</a
          >
        </b-row>
      </div>
      <m-card-order
        v-if="position3 == 'saveOrder'"
        :orders="states.saveOrder"
        orderType="savedOrder"
        ><span slot="title">Saved Order</span>
        <a slot="footer" :href="$store.getters['config/link']('mysavecount')"
          >VIEW MORE ></a
        ></m-card-order
      >
      <m-card-order
        v-if="position3 == 'recentOrder'"
        :orders="states.recentOrder"
        orderType="recentOrder"
        ><span slot="title">Recent Order</span>
        <a slot="footer" :href="$store.getters['config/link']('history')"
          >VIEW MORE ></a
        ></m-card-order
      >
    </b-col>
  </b-row>
</template>

<script>
import MCardOrder from "@/components/landings/MCardOrder";
import MDataDiagnostic from "@/components/landings/MDataDiagnostic";
export default {
  components: {
    MCardOrder,
    MDataDiagnostic,
  },
  data() {
    return {
      states: this.$store.state.user,
    };
  },
  computed: {
    position1() {
      if (!this.states.init.userPoint) {
        return "blank";
      } else {
        return "point";
      }
    },
    position2() {
      if (!this.states.init.recentOrder || !this.states.init.saveOrder) {
        return "blank";
      } else if (
        (this.states.recentOrder.length === 0) &
        (this.states.saveOrder.length === 0)
      ) {
        return "video";
      } else if (
        this.states.saveOrder.length > 0 &&
        this.states.recentOrder.length > 0
      ) {
        return "recentOrder";
      } else {
        return "video";
      }
    },
    position3() {
      if (!this.states.init.recentOrder || !this.states.init.saveOrder) {
        return "blank";
      } else if (
        (this.states.recentOrder.length === 0) &
        (this.states.saveOrder.length === 0)
      ) {
        return "refer";
      } else if (this.states.saveOrder.length > 0) {
        return "saveOrder";
      } else {
        return "recentOrder";
      }
    },
  },
  methods: {
    dataDiagnostic() {
      this.$root.$emit("bv::show::modal", "modalDataDiagnostic");
    },
  },
};
</script>

<style scoped>
.m-card {
  margin-top: 24px;
  background-color: #fff;
  padding: 24px;
  font-size: 0.9em;
  min-height: 240px;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  padding-top: 20px;
  padding-bottom: 0;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
}

.m-card-title {
  /*font-size: 1em;*/
  color: #000000;
  font-size: 18px;
  /*font-weight: 600;*/
}

.m-cards-col {
  padding-left: 3px;
  padding-right: 3px;
}
/* loader */
.spinner {
  width: 30px;
  height: 30px;
  background-color: #efefef;

  margin: 70px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}
.user {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  vertical-align: middle;
  margin-right: 10px;
}
.user.x-large {
  width: 55px;
  height: 55px;
  border: 1px solid #e04557;
}
.user.xx-large {
  width: 120px;
  height: 120px;
}
#rewards {
  margin-top: 10px;
  font-size: 18px;
  color: #000000;
}
span.dated {
  font-size: 14.3px;
}
.points {
  color: #e04557;
  font-size: 30px;
}
.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 5px;
  padding-left: 5px;
}
.justify-content-center {
  margin-top: 16px;
}
.btn-outline-primary:hover {
  background-color: #e04557 !important;
  color: #ffffff !important;
  border-color: #e04557 !important;
}
.btn-outline-primary {
  font-weight: bold !important;
}
a {
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/components/landings/MUserData.vue